import { ApiConfig } from '@eng-dx-gpt/api-client';

/**
 * Virtual Assistant microservice API configuration
 * All endpoints related to mother agents, virtual agents, intents, and playground
 */
export const virtualAssistantBackendConfig: ApiConfig[] = [
    // Mother Agent Controller
    {
        name: 'getMotherAgentById',
        method: 'GET',
        url: '/mother-agent/{id}',
        service: 'va'
    },
    {
        name: 'putMotherAgentById',
        method: 'PUT',
        url: '/mother-agent/{id}',
        service: 'va'
    },
    {
        name: 'deleteMotherAgentById',
        method: 'DELETE',
        url: '/mother-agent/{id}',
        service: 'va'
    },
    {
        name: 'getMotherAgent',
        method: 'GET',
        url: '/mother-agent',
        service: 'va'
    },
    {
        name: 'postMotherAgent',
        method: 'POST',
        url: '/mother-agent',
        service: 'va'
    },
    {
        name: 'cloneMotherAgent',
        method: 'PATCH',
        url: '/mother-agent/clone/{id}',
        service: 'va'
    },
    {
        name: 'publishMotherAgent',
        method: 'PATCH',
        url: '/mother-agent/{id}/publish/start',
        service: 'va'
    },
    {
        name: 'unpublishMotherAgent',
        method: 'PATCH',
        url: '/mother-agent/{id}/publish/stop',
        service: 'va'
    },
    {
        name: 'createIntentForMotherAgent',
        method: 'PATCH',
        url: '/mother-agent/{id}/intent',
        service: 'va'
    },
    {
        name: 'getPlayground',
        method: 'GET',
        url: '/mother-agent/{motherAgentId}/playground',
        service: 'va'
    },
    {
        name: 'startPlayground',
        method: 'PATCH',
        url: '/mother-agent/{id}/playground/start',
        service: 'va'
    },
    {
        name: 'getPlaygroundStatus',
        method: 'PATCH',
        url: '/mother-agent/{id}/playground/status',
        service: 'va'
    },

    // Intent Controller
    {
        name: 'getIntentById',
        method: 'GET',
        url: '/intent/{id}',
        service: 'va'
    },
    {
        name: 'putIntentById',
        method: 'PUT',
        url: '/intent/{id}',
        service: 'va'
    },
    {
        name: 'deleteIntentById',
        method: 'DELETE',
        url: '/mother-agent/{motherAgentId}/intent',
        service: 'va'
    },
    {
        name: 'getIntent',
        method: 'GET',
        url: '/intent',
        service: 'va'
    },
    {
        name: 'postIntent',
        method: 'POST',
        url: '/intent',
        service: 'va'
    },

    // Virtual Agent Controller
    {
        name: 'getAgentById',
        method: 'GET',
        url: '/agent/{id}',
        service: 'va'
    },
    {
        name: 'putAgentById',
        method: 'PUT',
        url: '/agent/{id}',
        service: 'va'
    },
    {
        name: 'deleteAgentById',
        method: 'DELETE',
        url: '/agent/{id}',
        service: 'va'
    },
    {
        name: 'getAgent',
        method: 'GET',
        url: '/agent',
        service: 'va'
    },
    {
        name: 'postAgent',
        method: 'POST',
        url: '/agent',
        service: 'va'
    }
];
